(() => {
  if (window.__lmcdGoodBeautifulScript) return;
  window.__lmcdGoodBeautifulScript = true;
  function init(root) {
    if (root.dataset.gbReady === 'true') return;
    root.dataset.gbReady = 'true';
    const cleanup = [];
    const listen = (target, type, handler, options) => {
      if (!target) return;
      target.addEventListener(type, handler, options);
      cleanup.push(() => target.removeEventListener?.(type, handler, options));
    };

    const mainImage = root.querySelector('[data-gb-gallery-main]');
    const thumbs = [...root.querySelectorAll('[data-gb-gallery-thumb]')];
    let galleryIndex = Math.max(0, thumbs.findIndex((thumb) => thumb.getAttribute?.('aria-current') === 'true'));
    const selectThumb = (thumb) => {
      if (!thumb || !mainImage) return;
      galleryIndex = Math.max(0, thumbs.indexOf(thumb));
      mainImage.src = thumb.dataset.gbSrc;
      mainImage.alt = thumb.dataset.gbAlt || '';
      thumbs.forEach((item) => {
        const current = item === thumb;
        item.setAttribute('aria-current', String(current));
        item.classList?.toggle('is-current', current);
      });
      thumb.scrollIntoView?.({block: 'nearest', inline: 'nearest', behavior: 'smooth'});
    };
    thumbs.forEach((thumb) => listen(thumb, 'click', (event) => {
      event.preventDefault();
      selectThumb(thumb);
    }));

    const hiddenVariant = root.querySelector('.gb-product-form [name="id"]');
    const productPrice = root.querySelector('[data-gb-product-price]');
    const comparePrice = root.querySelector('[data-gb-product-compare-price]');
    const availability = root.querySelector('[data-gb-availability]');
    const addToCart = root.querySelector('[data-gb-add-to-cart]');
    const morePayment = root.querySelector('[data-gb-more-payment]');
    const stickyPrice = root.querySelector('[data-lmcd-house-sticky-cta] [data-lmcd-sale-current]');
    const stickySubmit = root.querySelector('[data-lmcd-house-sticky-submit]');
    const styleOptions = [...root.querySelectorAll('[data-gb-style-option]')];
    styleOptions.forEach((input) => {
      listen(input, 'change', () => {
        if (!input.dataset.gbVariantId) return;
        styleOptions.forEach((item) => item.closest?.('.gb-style')?.classList.toggle('is-selected', item.checked));
        hiddenVariant.value = input.dataset.gbVariantId;
        root.dataset.variantId = input.dataset.gbVariantId;
        root.dataset.lmcdUnitPriceCents = input.dataset.gbPriceCents;
        if (productPrice) productPrice.textContent = input.dataset.gbPrice;
        if (stickyPrice) stickyPrice.textContent = input.dataset.gbPrice;
        const hasComparePrice = input.dataset.gbHasComparePrice === 'true';
        if (comparePrice) {
          comparePrice.textContent = input.dataset.gbComparePrice || '';
          comparePrice.hidden = !hasComparePrice;
        }
        const available = input.dataset.gbAvailable === 'true';
        if (availability) availability.textContent = available ? 'Available' : 'Sold out';
        if (addToCart) {
          addToCart.disabled = !available;
          addToCart.textContent = available ? `Add to cart | ${input.dataset.gbPrice}` : 'Sold out';
        }
        if (morePayment) morePayment.disabled = !available;
        if (stickySubmit) {
          stickySubmit.disabled = !available;
          stickySubmit.textContent = available ? 'Add to cart' : 'Sold out';
        }
        const index = Number(input.dataset.gbGalleryIndex || 1) - 1;
        selectThumb(thumbs[index]);
      });
    });

    const stepGallery = (step) => {
      if (!thumbs.length) return;
      selectThumb(thumbs[(galleryIndex + step + thumbs.length) % thumbs.length]);
    };
    listen(root.querySelector('[data-gb-gallery-prev]'), 'click', () => stepGallery(-1));
    listen(root.querySelector('[data-gb-gallery-next]'), 'click', () => stepGallery(1));

    const galleryStage = root.querySelector('.gb-gallery__stage');
    let swipeStart = null;
    listen(galleryStage, 'pointerdown', (event) => { swipeStart = event.clientX; });
    listen(galleryStage, 'pointerup', (event) => {
      if (swipeStart === null) return;
      const distance = event.clientX - swipeStart;
      swipeStart = null;
      if (Math.abs(distance) > 45) stepGallery(distance < 0 ? 1 : -1);
    });

    const zoomDialog = root.querySelector('[data-gb-zoom-dialog]');
    const zoomImage = root.querySelector('[data-gb-zoom-image]');
    listen(root.querySelector('[data-gb-zoom]'), 'click', () => {
      if (!zoomDialog || !mainImage) return;
      if (zoomImage) {
        zoomImage.src = mainImage.src;
        zoomImage.alt = mainImage.alt;
      }
      if (zoomDialog.showModal) zoomDialog.showModal();
      else zoomDialog.setAttribute('open', '');
    });
    listen(root.querySelector('[data-gb-zoom-close]'), 'click', () => zoomDialog?.close?.());
    listen(zoomDialog, 'click', (event) => { if (event.target === zoomDialog) zoomDialog.close?.(); });

    const primaryForm = root.querySelector('#gb-primary-product-form');
    listen(morePayment, 'click', (event) => {
      event.preventDefault();
      if (!morePayment.disabled) primaryForm.requestSubmit();
    });
    if (stickySubmit?.disabled) {
      listen(stickySubmit, 'click', () => {
        if (!stickySubmit.disabled) primaryForm?.requestSubmit?.();
      });
    }

    const menuButton = root.querySelector('[data-gb-menu-toggle]');
    const mobileNav = root.querySelector('[data-gb-mobile-nav]');
    listen(menuButton, 'click', () => {
      const opening = mobileNav.hidden;
      mobileNav.hidden = !opening;
      menuButton.setAttribute('aria-expanded', String(opening));
    });

    [...root.querySelectorAll('[data-gb-next]')].forEach((button) => {
      listen(button, 'click', () => {
        const section = button.closest?.('.gb-carousel-section');
        const rail = section?.querySelector?.('[data-gb-rail]');
        rail?.scrollBy?.({left: rail.clientWidth * .82, behavior: 'smooth'});
      });
    });

    const trustRail = root.querySelector('[data-gb-trust-rail]');
    const trustDots = [...root.querySelectorAll('[data-gb-trust-dot]')];
    const selectTrust = (index) => {
      if (trustRail) trustRail.style.transform = `translateX(-${index * 33.333}%)`;
      trustDots.forEach((dot, dotIndex) => dot.setAttribute('aria-current', String(dotIndex === index)));
    };
    trustDots.forEach((dot) => listen(dot, 'click', () => selectTrust(Number(dot.dataset.gbTrustDot))));

    const reviewPhotoRail = root.querySelector('[data-gb-review-photos]');
    const stepReviewPhotos = (direction) => {
      if (!reviewPhotoRail) return;
      reviewPhotoRail.scrollBy?.({left: direction * Math.max(reviewPhotoRail.clientWidth * .8, 220), behavior: 'smooth'});
    };
    listen(root.querySelector('[data-gb-review-photos-prev]'), 'click', () => stepReviewPhotos(-1));
    listen(root.querySelector('[data-gb-review-photos-next]'), 'click', () => stepReviewPhotos(1));

    const search = root.querySelector('[data-gb-review-search]');
    const reviewCards = [...root.querySelectorAll('[data-gb-review-card]')];
    const reviewList = root.querySelector('[data-gb-review-list]');
    const reviewSort = root.querySelector('[data-gb-review-sort]');
    reviewCards.forEach((card, index) => { card.dataset.gbOriginalIndex = String(index); });
    listen(reviewSort, 'change', () => {
      const ordered = [...reviewCards].sort((left, right) => {
        const a = Number(left.dataset.gbOriginalIndex);
        const b = Number(right.dataset.gbOriginalIndex);
        return reviewSort.value === 'oldest' ? b - a : a - b;
      });
      ordered.forEach((card) => reviewList.appendChild(card));
    });
    listen(search, 'input', () => {
      const query = search.value.trim().toLowerCase();
      reviewCards.forEach((card) => {
        const corpus = `${card.textContent.toLowerCase()} ${(card.dataset.gbReviewText || '').toLowerCase()}`;
        card.hidden = Boolean(query && !corpus.includes(query));
      });
    });

    [...root.querySelectorAll('.gb-disclosure')].forEach((details) => {
      listen(details, 'toggle', () => {
        const symbol = details.querySelector?.('summary span');
        if (symbol) symbol.textContent = details.open ? '−' : '+';
      });
    });

    if (window.matchMedia?.('(max-width: 749px)').matches) {
      [...root.querySelectorAll('.gb-footer__group')].forEach((details) => { details.open = false; });
    }

    root.__gbTeardown = () => {
      cleanup.splice(0).forEach((remove) => remove());
      zoomDialog?.close?.();
      zoomDialog?.removeAttribute?.('open');
      if (mobileNav) mobileNav.hidden = true;
      menuButton?.setAttribute('aria-expanded', 'false');
      delete root.dataset.gbReady;
      delete root.__gbTeardown;
    };
  }

  function start() {
    document.querySelectorAll('[data-good-beautiful-offer]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', start);
  document.addEventListener('shopify:section:unload', (event) => {
    const node = event.target;
    if (node.matches?.('[data-good-beautiful-offer]')) node.__gbTeardown?.();
    node.querySelectorAll?.('[data-good-beautiful-offer]').forEach((root) => root.__gbTeardown?.());
  });
})();
